// Vendor
import {
  updateAccessStatus,
  updateSending,
  updateInitApp,
  resetState
} from "vendor/application/disptach";
import $ from "jquery";

export class CustomLogin {
  constructor(body, url, props) {
    this.base_url = process.env.REACT_APP_URL_BACK;
    this.url = url;
    this.body = body;
    this.props = props;
  }

  async make_request_refresh() {
    const { access } = this.props.data;
    try {
      var result = await $.ajax({
        url: `${this.base_url}${this.url}`,
        type: "POST",
        data: JSON.stringify(this.body),
        headers: {
          "Content-Type": "application/json"
        }
      });
    } catch (error) {
      var result = { response: error, status: error.status };
    }

    switch (result.status) {
      case 400:
        this.props.dispatch(resetState());
        window.location.href = "http://localhost:3001/landing/login";
        throw "error";
      case 401:
        this.props.dispatch(updateInitApp(true));
        this.props.dispatch(updateSending(false));
        // this.props.history.push('/login');
        throw "The session has expired, Log In again";
      default:
        var obj = result;
        var acc = access;
        acc.access = obj.access;
        var data = { ...acc, isAccess: true, userId: access.userId };
        this.props.dispatch(updateAccessStatus(data));
        this.props.dispatch(updateSending(false));
        return obj;
    }
  }
}
